import React, { useEffect } from 'react';
import {
  ComponentFactory,
  ComponentParams,
  ComponentRendering,
  Field,
  Placeholder,
  RichText,
  SitecoreContext,
} from '@sitecore-jss/sitecore-jss-react';

import './index.scss';

export type OrderUnsuccessfulProps = {
  fields: {
    OrderUnsuccessfulText: Field<string>;
  };
  sitecoreContext: SitecoreContext & { pageEditing: boolean };
};

interface Props {
  children: React.ReactElement;
  componentFactory: ComponentFactory;
  rendering: ComponentRendering;
  params: ComponentParams;
}

const OrderUnsuccessful = (props: OrderUnsuccessfulProps & Props): JSX.Element => {
  const { fields, rendering } = props;
  useEffect(() => {
    window.history.replaceState(null, 'API WebStore | Cart', '/carts');
  }, []);

  return (
    <div className="centerContainer">
      <div className="orderUnsuccessfulSection">
        <div className="orderUnsuccessfulHeader">
          <h1>Order Unsuccessful</h1>
        </div>

        <div className="orderUnsuccessfulContent">
          <RichText className="orderUnsuccessfulRichText" field={fields?.OrderUnsuccessfulText} />
          <Placeholder name="continue_shopping" rendering={rendering} />
        </div>
      </div>
    </div>
  );
};

export default OrderUnsuccessful;
